module.exports = __webpack_public_path__ + "img/fqlc.dd9d0bd7.svg";